import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/pl';

$.fn.countrySelect = function(params) {
    var $this = $(this);
    $this.css('width', '100%');
    $(this).select2();
    
    $.ajax({
        url: '/ajax/get_available_countries',
        method: 'GET',
        success: function(response) {
            self.countries = response;
            var countries = response;

            for (let i = 0; i < $this.length; i++) {
                let temp_countries = countries;
                if ($this[i].classList.contains('only-send-from')) {
                    temp_countries = temp_countries.filter(function(country) {
                        return country.send_from === true;
                    });
                }
                $($this[i]).select2({data: temp_countries});
            }
            if (typeof params !== 'undefined' && typeof params.call_after_success !== 'undefined') {
                params.call_after_success();
            }
        },
    });
}
